export const generateNotebookName = (name: string, prefix: string): string => {
  const randomString = Math.random().toString(36).substring(2, 10);
  return `${prefix}_${name}_${randomString}`.replace(/[^a-zA-Z0-9_]/g, '_');
};

export const generateNotebookFunctionName = (
  name: string,
  prefix: string,
): string => {
  const randomString = Math.random().toString(36).substring(2, 10);
  return `${prefix}_${name}_${randomString}`.replace(/[^a-zA-Z0-9_]/g, '_');
};
